/* eslint-disable */
import {
  createContext,
  useContext,
  useReducer,
  useMemo,
  useEffect,
} from "react";
import api from "api";
import qs from "qs";
import { NotificationManager } from "react-notifications";
import axios from "axios";
// Auth context
const authContext = createContext();
// Setting custom name for the context which is visible on react dev tools
authContext.displayName = "Auth Context";

// reducer
function reducer(state, action) {
  switch (action.type) {
    case "INIT": {
      return { ...state, ...action.payload };
    }
    case "LOGIN": {
      return { ...state, ...action.value, isLoggedIn: true };
    }
    case "SET_USER_DETAILS": {
      return { ...state, ...action.value, userDetails: action.value };
    }
    case "LOGOUT": {
      return { token: "", isLoggedIn: false };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}
const expiration = localStorage.getItem("expiration");
let token;
// if token is expired, logout
if (expiration && Number(expiration) > new Date().getTime()) {
  token = localStorage.getItem("token");
} else {
  localStorage.removeItem("token");
}
// context provider
function AuthContextProvider({ children }) {
  const initialState = {
    token,
    isLoggedIn: !!token,
  };

  const [controller, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => [controller, dispatch], [controller, dispatch]);

  return <authContext.Provider value={value}>{children}</authContext.Provider>;
}

// custom hook for using context
function useAuth() {
  const context = useContext(authContext);

  if (!context) {
    throw new Error("useAuth should be used inside the AuthContextProvider.");
  }

  return context;
}

const handleLogin = async (dispatch, value) => {
  try {
    const data = {
      username: value.username,
      password: value.password,
      client: "referer",
      referer: window.location.origin,
      expiration: 720,
      f: "json",
    };
    const url = process.env.REACT_APP_TOKEN_GENERATOR;
    let options = {
      method: "POST",
      headers: { "content-type": "application/x-www-form-urlencoded" },
      data: qs.stringify(data),
      url,
    };
    const res = await axios(options);

    if (res.data.error) {
      throw res.data.error;
    }

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("expiration", res.data.expires);
    localStorage.setItem("username", value.username);

    dispatch({
      type: "LOGIN",
      value: {
        token: res.data.token,
      },
    });
    NotificationManager.success("Logged In Sucessfuly");
    return true;
  } catch (error) {
    if (error && error.response) {
      NotificationManager.error(error.response.data.message);
    }
    console.log(error);
  }
};

const handleLogout = async (dispatch) => {
  try {
    localStorage.clear();
    dispatch({ type: "LOGOUT" });
    NotificationManager.success("Logged Out Sucessfuly");
  } catch (error) {
    console.log(error);
  }
};

export {
  AuthContextProvider,
  useAuth,
  handleLogin,
  handleLogout,
};
